export const questions = {
    "quizTitle": "Manevra navei. Meteorologie. Hidrologie. – CLASA A,B",
    "quizSynopsis": "Model Manevra / Meteo / Hidrologie · 30 min · minim 21/30 (barem 7)",
    "progressBarColor": "#9de1f6",
    "nrOfQuestions": "179",
    "examConfig": {
        "personnelCategory": "CLASA A,B",
        "timeMinutes": 30,
        "passPercent": 70,
        "minCorrect": 21,
        "barem": 7,
        "modelName": "Manevra navei. Meteorologie. Hidrologie.",
        "sections": [
            {
                "id": "Manevra meteo hidrologie",
                "label": "Manevra / Meteo / Hidrologie",
                "count": 30,
                "difficulty": 1
            }
        ],
        "totalQuestions": 30
    },
    "appLocale": {
        "landingHeaderText": "<questionLength> Intrebari",
        "question": "Intrebare",
        "startQuizBtn": "Incepe",
        "resultFilterAll": "Toate",
        "resultFilterCorrect": "Correct",
        "resultFilterIncorrect": "Incorect",
        "prevQuestionBtn": "Inapoi",
        "nextQuestionBtn": "Inainte",
        "multipleSelectionTagText": "Selectie multipla",
        "resultPageHeaderText": "Ai terminat. Ai <correctIndexLength> raspunsuri corecte din <questionLength> total.",
        "pickNumberOfSelection": "Alege <numberOfSelection>",
        "marksOfQuestion": "(<marks> puncte)"
    },
    "questions": [
        {
            "question": "1. La deplasarea înainte a bărcii, efectul cârmei determină",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) orientarea provei în vânt",
                "b) orientarea provei în bordul în care s-a pus cârma şi a pupei în bordul opus",
                "c) mersul în linie dreaptă"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "2. La marş înainte, pupa este abătută",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) spre dreapta",
                "b) în bordul pasului elicei, iar prova are tendinţa să gireze în bordul opus pasului elicei",
                "c) spre stânga"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "3. Acostarea ambarcaţiunii la mal neamenajat",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu este recomandată",
                "b) se face cu vigilenţă sporită, protejând elicea şi cârma",
                "c) este interzisă"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "4. Depăşirile se execută",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la o distanță cât mai mare de nava depăşită, viteza se adaptează situaţiei, urmărind a nu face valuri pentru nava depăşită, dar acordând atenţia necesară întâmpinării valurilor din siajul acesteia",
                "b) de către ambarcaţiunea care merge pe mijlocul şenalului",
                "c) oricum deoarece nu sunt reguli speciale de siguranţă în cazul acestei manevre"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "5. Remorcarea este o operaţiune la care lungimea parâmei de remorcă",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) se va alege astfel încât nava remorcată să nu suporte curentul respins de elicea navei remorcher",
                "b) nu contează lungimea parâmei de legare",
                "c) nu se fac remorcări cu ambarcaţiuni"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "6. Înainte de pătrunderea în ecluză",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu trebuiesc făcute pregătiri speciale la bordul ambarcaţiunilor",
                "b) la bordul ambarcaţiunilor parâmele trebuie ţinute din scurt şi componentele echipamentului trebuie să nu depăşească limitele navei",
                "c) conducătorul nu are nici o obligaţie"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "7. Din motive de siguranţă şi fluidizare a circulaţiei, pentru accelerarea traversării şi pentru exploatarea în plin a ecluzelor",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) personalul de supraveghere a ecluzelor poate emite ordine care să completeze regulile iniţial prevăzute sau care se abat de la acestea, iar conducătorii navelor trebuie să urmeze aceste ordine în zona de ecluzare",
                "b) personalul de supraveghere a ecluzelor nu are permisiunea de a emite ordine care să completeze regulile iniţial prevăzute",
                "c) este permisă orice măsură propusă de conducătorii navelor"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "8. În funcţie de tipul cocii, viteza bărcii este cu atât mai mare cu cât",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) suprafaţa udată la viteza maximă este mai mare",
                "b) suprafaţa udată la viteza maximă este mai mică",
                "c) elicea are mai multe pale"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "9. Înainte de a părăsi locul de acostare",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) îndepărtaţi orice material în plus din barca şi lăsaţi-l la ţărm; dacă aveţi nevoie de el la bord, asiguraţi-vă că este depozitat în siguranţă",
                "b) nu este nevoie de asemenea pregătire",
                "c) puteţi depozita materialele după libera dvs. alegere"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "10. Alegerea celei mai bune elice şi a înălţimii motorului necesită verificarea câtorva lucruri precum",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) turaţia maximă a motorului; viteza bărcii; ventilaţia elicei; abilitatea de glisare a bărcii; presiunea de răcire",
                "b) lungimea bărcii",
                "c) pescajul şi lăţimea bărcii"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "11. Numărul de ture pe care îl efectuează o elice în mişcarea sa de rotaţie într-un interval de timp de un minut reprezintă",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) numărul de rotaţii al elicei pe minut (RPM)",
                "b) spaţiul parcurs de elice într-un minut",
                "c) viteza de rotaţie a elicei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "12. Legăturile ambarcaţiunii sunt",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) parâma pupa",
                "b) parâma prova şi pupa",
                "c) parâma prova"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "13. Locul de ancorare trebuie să îndeplinească o serie de condiţii",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să permită o ancorare- plecare uşoară, fără să deranjeze alte ambarcaţiuni",
                "b) nu sunt impuse condiţii speciale pentru ancorare",
                "c) este interzisă ancorarea în afara radelor"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "14. În cazul în care nu putem observa în mod clar felul cum acţionează curentul şi vântul în cazul manevrei de ,,Om la apă”",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu facem manevra de recuperare a celui căzut în apă",
                "b) venim iniţial cu prova pe direcţia inversă a rezultantei, căutând efectul minim de derivă şi ne apropiem de cel căzut în apă cu viteza scăzută",
                "c) nu este nevoie de nici o estimare a efectului curentului si vântului"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "15. În timpul ecluzării, în camerele ecluzelor",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) este interzisă curăţarea şi maturarea navelor şi corpurilor flotante",
                "b) este permisă curăţarea şi maturarea navelor şi corpurilor flotante",
                "c) nu este prevăzută expres această regulă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "16. Conducerea de motovehicule nautice (skyjet) este supusă următoarelor limite",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) motorul nu se opreşte la căderea conducătorului",
                "b) regulile de construcţie privesc pe constructor",
                "c) motorul trebuie sau să se oprească automat la căderea conducătorului, sau să fie cuplat automat pe cea mai mică viteză, în timp ce vehiculul trebuie să se oprească sau să descrie o traiectorie circulară"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "17. Dacă barca dumneavoastră este echipată cu un sistem de cablu împinge- trage, mecanic",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) toate componentele sistemului trebuie să îndeplinească sau să depăşească cererile menţionate în standard",
                "b) componentele sistemului pot fi alese după aprecierea proprietarului",
                "c) nu există reguli şi standarde pentru această instalaţie"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "18. Manevra de oprire se execută astfel",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) in cazul in care nu exista nici un motiv sa faceţi altfel, reduceţi in mod gradat viteza, deoarece reducerea brusca poate face ca valul de pupa sa se lovească de oglinda bărcii si sa se reverse in interior",
                "b) ambarcaţiunea se opreşte rapid, prin punerea pe zero si cuplarea pe înapoi a motorului",
                "c) barca se opreşte din mers prin scoaterea cheii din contact"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "19. Dacă înclinaţi motorul în sus la viteze mari",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu se observa nici un efect",
                "b) forţele turbionare vor acţiona brusc şi pot cauza pierderea controlului ambarcaţiunii",
                "c) barca se înclină în bordul pasului elicei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "20. La acostare se folosesc",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) baloane de protecţie polivinilice umplute cu aer",
                "b) corpul ambarcaţiunii nu se protejează",
                "c) orice fel de obiecte din metal sau lemn"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "21. Cu cât viteza de deplasare este mai mare",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) presiunea apei asupra penei cârmei va fi mai mare, iar schimbarea direcţiei mai rapidă",
                "b) presiunea apei asupra penei cârmei va fi mai mică, iar schimbarea direcţiei mai înceată",
                "c) viteza nu influenţează rapiditatea schimbării direcţiei de navigaţie"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "22. Mărimea şi forma elicei depinde de",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) turaţia dată la axul elicei",
                "b) puterea motorului, mărimea corpului ambarcaţiunii şi scopul pentru care este destinată barca, tracţiune sau viteză",
                "c) parametrii motorului"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "23. Guvernarea poate fi îLma bmuannăetăvrţiat ăd ed e:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) reducerea numărului de cârme",
                "b) mărimea suprafeţei penei cârmei",
                "c) micşorarea unghiului de rotire a cârmei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "24. acostare, pe lângă calităţile manevriere ale navei, tot timpul se va ţine cont de vânt şi curent urmărindu-se",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să se evite influenţa lor",
                "b) ca forţa acestora să fie folosită în ajutorul manevrei şi nu manevra săse împotrivească acestora",
                "c) nu se ţine cont de vânt şi curent"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "25. Manevra de ”Om la apă“ este o manevră clasică de recuperare care se efectuează",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) vântului şi curentului asupra ambarcaţiunii şi persoanei căzute în apă, astfel încât ambarcaţiunea să nu derive peste omul",
                "b) nu este nevoie de nici o estimare a efectului curentului si vântului",
                "c) această manevră o fac numai navele de salvare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "26. În camerele ecluzei:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu se folosesc baloanele/trancheţi pentru acostare",
                "b) este obligatorie folosirea trancheţilor pentru acostare",
                "c) se folosesc trancheţi care trebuie să fie flotabili, dacă nu sunt legaţi strâns- fixaţi de navă"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "27. Conducerea de motovehicule nautice (skyjet-uri) este supusă următoarelor limite",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) se poate naviga atât ziua cât şi noaptea",
                "b) este permisă numai ziua",
                "c) nu sunt prevăzute reguli exprese"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "28. Indicatorul înclinării este folosit",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la ridicarea cizmei/motorului pentru controlul elicei",
                "b) numai de persoanele autorizate",
                "c) sa orienteze motorul la un unghi predeterminat pentru o performanţă mai bună în navigaţie"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "29. Înainte de a părăsi locul de acostare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) asiguraţi-vă că operaţiunile de pe algoritmul verificărilor dumneavoastră au fost parcurse",
                "b) nu se fac nici un fel de verificări",
                "c) toate verificările sunt făcute de către un service"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "30. Pasul elicei reprezintă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) mărimea diametrului butucului",
                "b) lungimea palei",
                "c) spaţiul parcurs de marginea exterioară a elicei in mişcarea de translaţie efectuată de-a lungul axei de rotaţie în timpul unei rotaţii complete"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "31. Locul de ancorare trebuie să îndeplinească o serie de condiţii:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) este interzisă ancorarea în afara radelor",
                "b) să fie un loc ferit de efectele curenţilor, valurilor şi vântului",
                "c) nu sunt impuse condiţii speciale pentru ancorare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "32. În categoria ecluzelor intră:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) ecluzele şi suprafeţele de apă dinăuntrul şi dinafara sasurilor ecluzelor care servesc legării la cheu, înşiruirii şi aşteptării navelor –avanporturile de ecluză",
                "b) barajele şi porţile amonte şi aval",
                "c) numai sasurile ecluzelor"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "33. În timpul ecluzării, în camerele ecluzelor",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) ambarcaţiunile mici pot să staţioneze oriunde in interiorul camerei",
                "b) ambarcaţiunile mici nu au voie să ecluzeze",
                "c) ambarcaţiunile mici trebuie să păstreze suficientă distanţă faţă de alte nave"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "34. Conducerea de motociclete nautice (skyjet) este supusă următoarelor limite:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) conducătorul şi însoţitorul trebuie să poarte veste de salvare",
                "b) conducătorul şi însoţitorul nu trebuie să poarte veste de salvare",
                "c) conducătorul şi însoţitorul nu trebuie să poarte veste de salvare, dacă sunt buni înotători"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "35. Mişcarea transversală a unei nave în jurul unei axe longitudinale reprezintă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tangaj",
                "b) ruliu",
                "c) mişcare ascensională"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "36. \"Mărimea’’ forţei ce acţionează asupra timonei este influenţată de",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) puterea motorului, de câtă porţiune din elice este în apă, de tipul şi pasul elicei",
                "b) numai de puterea motorului",
                "c) numai de pasul elicei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "37. Instalaţia de guvernare se compune din",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) timonă şi transmisie",
                "b) timona sau manipulatorul electric; servomotorul la navele mari; sistemul de transmisie timonă- servomotor-cârmă; cârma propiu-zisă",
                "c) timona"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "38. Elicea are pas stânga dacă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la mersul înainte al ambarcaţiunii elicea se învârte la dreapta",
                "b) la mersul înapoi al ambarcaţiunii elicea se învârte la dreapta",
                "c) la mersul înainte al ambarcaţiunii elicea se învârte la stânga"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "39. În cazul acostării cu bordul:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nava se apropie de cheu sub un unghi ascuţit, pentru a atenua impactul provei cu cheul",
                "b) ambarcaţiunea se apropie de cheu pe o direcţie perpendiculară pe acesta",
                "c) ambarcaţiunea se apropie de cheu din orice pozitie"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "40. Reuşita ancorării depinde şi de folosirea corectă a lungimii parâmei/lanţului de ancorare şi anume",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu sunt stabilite reguli speciale privind lungimea lanţului/parâmei de ancorare",
                "b) lungimea parâmei/lanţului de ancorare nu influenţează siguranţa ancorării",
                "c) lungimea parâmei/lanţului la ancoră trebuie să fie de 3- 5 ori adâncimea"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "41. În zona de ecluzare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) ancorele trebuie să fie ridicate la post şi asigurate",
                "b) ancorele pot fi folosite în ecluză",
                "c) nu sunt prevăzute reguli speciale pentru acest caz"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "42. O ambarcaţiune este dificil de controlat în timpul navigaţiei dacă este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) echipată cu motoare de puteri mai mari decât cea pentru care a fost proiectată (,,overpower’’)",
                "b) este echipată cu motoare cu putere asemănătoare cu cea pentru care a fost proiectată",
                "c) nu este importantă puterea motorului"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "43. Dacă barca devine instabilă",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) măriţi viteza pentru a stabiliza deplasarea",
                "b) reduceţi viteza în mod gradat, nu acceleraţi, opriţi testul de navigaţie în viteza pe apă, apoi verificaţi barca şi echipamentul, iar în cazul în care consideraţi că este nevoie, contactaţi-vă dealer-ul sau un expert pentru a vă ajuta",
                "c) nu este nevoie de nici o verificare, continuaţi mersul la aceeaşi parametri, deoarece fenomenul de instabilitate dispare după scurt timp"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "44. Pentru alegerea elicei care să corespundă exigenţelor dvs. trebuie să ţineţi cont de următoarele elemente",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tonajul bărcii",
                "b) experienţa conducătorului",
                "c) viteza probabilă a bărcii, care este cea mai bună elice pentru designul şi viteza bărcii dumneavoastră; modul în care doriţi să folosiţi barca; testarea pasului elicei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "45. Înmulţind rotaţiile pe minut (RPM) cu pasul elicei, se obţine:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) valoarea rezistenţei elicei",
                "b) spaţiul parcurs de ambarcaţiune într-un minut",
                "c) numărul de pale de elice"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "46. Locul de ancorare trebuie să îndeplinească o serie de condiţii:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu sunt impuse condiţii speciale pentru ancorare",
                "b) este interzisă ancorarea în afara radelor",
                "c) să permită plecarea rapidă a navei de la ancoră, în orice condiţii, ziua sau noaptea"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "47. În zona de ecluzare este interzisă depăşirea, navele au voie să treacă pe lângă alte nave care aşteaptă în ecluză:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) atunci când conducătorul sau pasagerii consideră necesar",
                "b) numai atunci când ambarcaţiunile trebuie să fie ecluzate înainte sau pentru a se poziţiona în spaţiile libere aflate la îndemână",
                "c) ori de câte ori conducătorul consideră că este o manevră sigură"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "48. Înainte de pătrunderea în ecluză",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu trebuie făcute pregătiri speciale la bordul ambarcaţiunilor",
                "b) la bordul ambarcaţiunilor parâmele trebuie ţinute din scurt si componentele echipamentului trebuie să nu depăşească limitele navei",
                "c) conducătorul nu are nici o obligaţie"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "49. În timpul ecluzării, în camerele ecluzelor",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) este permis să se lase pasagerii să urce sau să coboare de la bord",
                "b) este interzis să se lase pasagerii să urce sau să coboare fără permisiunea personalului ecluzei",
                "c) nu este prevăzută expres această regulă"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "50. Conducerea de skyjet este supusă următoarelor limite",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pe skyjet trebuie să se aplice numere de înmatriculare vizibile acordate de căpitănie",
                "b) pe skyjet nu trebuie să se aplice numere de înmatriculare, deoarece nu este loc",
                "c) nu sunt reguli prevăzute expres"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "51. Conducătorul ambarcațiunii:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) poate să dea drumul timonei la orice viteză a bărcii",
                "b) poate să balanseze timona la o viteză mare a bărcii",
                "c) nu ar trebui să dea drumul timonei la nici un fel de viteză, din cauza forţelor turbionare prezente în sistemul de guvernare, barca ar putea să înceapă să se rotească rapid şi să devină instabilă"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "52. Un motor înclinat în sus",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) are o abilitate de frânare mai redusă decât unul înclinat în jos şi este nevoie de mai mult spaţiu pentru a opri barca",
                "b) are o abilitate de a opri mai uşor barca",
                "c) nu are nici un fel de influenţă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "53. Schimbarea direcţiei de deplasare a ambarcaţiunii se realizează prin",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) navigarea în ape cu salinități diferite",
                "b) punerea cârmei într-un bord sau altul şi este determinată de forţa curentului care apasă asupra penei cârmei, sau orientarea propulsorului în cazul propulsiei în ,,Z’’",
                "c) ambarcaţiunea schimbă direcţia când este influenţată de curent şi vânt"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "54. Prin rotaţia elicei se generează efect de",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) propulsie şi guvernare",
                "b) propulsie",
                "c) guvernare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "55. Dacă înclinaţi motorul în sus la viteze mari",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu se observa nici un efect",
                "b) forţele turbionare vor acţiona brusc şi pot cauza pierderea controlului ambarcaţiunii",
                "c) barca se înclină în bordul pasului elicei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "56. La trecerea prin avanporturi de ecluză şi la intrarea în ecluze, navele trebuie:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să-şi micşoreze viteza, pentru a fi posibilă în orice condiţii o oprire sigură cu ajutorul cablurilor de oţel, parâmelor şi a altor măsuri potrivite, astfel încât să fie exclusă o coliziune cu porţile ecluzei sau cu dispozitivele de protecţie, ca şi cu alte nave care au corpuri flotante",
                "b) să execute manevra de intrare cu viteza cea mai mare pentru reducerea timpului de staţionare în ecluză",
                "c) nu sunt impuse reguli speciale"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "57. Ordinea ecluzării este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu există reguli privind ordinea ecluzării",
                "b) navele administraţiei; navele care sunt plecate pentru îndeplinirea unor misiuni excepţionale; navele avariate grav au prioritate la ecluzare in faţa celorlalte, fără a sta la rând; navele de pompieri şi de salvare aflate în drum spre locul accidentului; celelalte nave",
                "c) operatorul ecluzei dispune cum crede de cuviinţă"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "58. O persoană care nu este pregătită pentru operarea unei bărci de mare viteză",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) poate încerca să conducă, crescând succesiv viteza fără instruire din partea unor conducători mai experimentaţi",
                "b) nu este nici o problemă, deoarece nu există riscuri",
                "c) nu ar trebui să încerce să conducă fără o instruire prealabilă şi o aplicaţie practică cu un conducător experimentat sau un dealer, pierderea controlului ar putea avea ca rezultat accidente grave"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "59. Înainte de a părăsi locul de acostare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu se fac nici un fel de verificări",
                "b) asiguraţi-vă că toate mecanismele folosite pentru a ataşa motorul de barcă sunt bine strânse şi la locul lor, procedaţi la fel pentru toată aparatura din sistemul de guvernare",
                "c) nu sunt reguli prevăzute expres"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "60. Ce fenomene hidrologice şi meteorologice pot influenţa manevra navei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) vântul, valurile, curentul, adâncimi mari",
                "b) vântul, valurile, curentul",
                "c) vântul, valurile, curentul, adâncimi mici"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "61. În cazul în care ambarcaţiunea dvs. este utilizată în regim de mare viteză în mod constant, este nevoie:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să alimentaţi mai des barca cu combustibil",
                "b) să schimbaţi uleiul mai des",
                "c) să fie verificate instalaţiile de elevare a motorului, de guvernare şi de cuplare-accelerare, precum şi elicea/elicele, la intervale mai scurte de timp"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "62. În ce constă manevrabilitatea bărcii?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) manevrabilitatea constă în capacitatea bărcii de a-şi menţine direcţia de înaintare sau de a schimba această direcţie cu ajutorul cârmei şi elicei",
                "b) manevrabilitatea consta in incapacitatea bărcii de a-si menţine direcţia de înaintare",
                "c) nu este o definiţie prevăzuta pentru aceasta caracteristica a ambarcaţiunii"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "63. Elicea are pas dreapta dacă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la mersul înainte al ambarcaţiunii elicea se învârte la dreapta",
                "b) la mersul înapoi al ambarcaţiunii elicea se învârte la dreapta",
                "c) la mersul înainte al ambarcaţiunii elicea se învârte la stânga"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "64. Manevrele de acostare și plecare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) sunt manevre simple, care nu solicită cunoştinţe de specialitate",
                "b) se fac numai cu piloţi specializaţi",
                "c) prezintă grad sporit de dificultate, solicitând cunoaşterea calităţilor manevriere ale navei și deprinderi marinăreşti"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "65. Reuşita ancorării depinde și de folosirea corectă a lungimii parâmei/lanţului de ancorare și anume:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lungimea parâmei/lanţului la ancoră trebuie să fie de 3-5 ori adâncimea măsurată",
                "b) nu sunt stabilite reguli speciale privind lungimea lanţului/parâmei de ancorare",
                "c) lungimea parâmei/lanţului de ancorare nu influenţează siguranţa ancorării"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "66. În zona de ecluze navele care sunt dotate cu o instalaţie de emisie–recepţie",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) închid aparatul VHF",
                "b) folosesc canalul pe care îl consideră util",
                "c) trebuie să aibă comutat la recepţie canalul ecluzei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "67. În timpul ecluzării, în camerele ecluzelor:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) este permis să se folosească după legarea navei și până la permiterea ieşirii atât propulsia mecanică, cât și instalaţia de guvernare prova",
                "b) nu este prevăzută expres această regulă",
                "c) este interzis să se folosească după legarea navei și până la permiterea ieşirii atât propulsia mecanică, cât și instalaţia de guvernare prova; din motive de siguranţă acest lucru este permis numai pentru fracţiuni scurte de timp"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "68. Motorul ataşabil al unei ambarcaţiuni se montează",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) având placa anticavitație la nivelul chilei ambarcaţiunii",
                "b) având placa anticavitație deasupra nivelului chilei ambarcaţiunii, la decalajul maxim permis de dispozitivul de fixare a motorului și dimensiunile oglinzii bărcii",
                "c) se poate monta oricum, deoarece nu sunt influenţaţi parametrii de mişcare ai bărcii"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "69. În cazul în care ambarcaţiunea dvs. este utilizată în regim de mare viteză în mod constant, este nevoie:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să alimentaţi mai des barca cu combustibil",
                "b) să schimbaţi uleiul mai des",
                "c) să fie verificate instalaţiile de elevare a motorului, de guvernare şi de cuplare-accelerare, precum şi elicea/elicele, la intervale mai scurte de timp"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "70. La marş înapoi, pupa este abătută:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) în bordul opus pasului elicei, iar prova va gira în bordul pasului elicei",
                "b) spre stânga",
                "c) spre dreapta"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "71. Acostarea ambarcaţiunii la o navă se face în următoarele condiţii",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nava la care urmează a se acosta reduce viteza și păstrează direcţia fără abatere, iar ambarcaţiunea va acosta totdeauna în bordul de sub vânt şi cât mai spre centrul navei",
                "b) nu contează condiţiile",
                "c) aceasta manevră este interzisă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "72. La întâlniri, conducătorul ambarcaţiunii",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) păstrează direcţia şi viteza de deplasare",
                "b) va reduce viteza în întâmpinarea valurilor provocate de nava ce vine din sens opus şi va adopta o viteză corespunzătoare evitării răsturnării",
                "c) se vor evita constant întâlnirile"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "73. În camerele ecluzei",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) navele trebuie să se menţină în interiorul limitelor, în cazul în care pe pereţii ecluzelor sunt marcate graniţe/limite",
                "b) navele se pot lega oriunde consideră",
                "c) nu este nevoie de legarea navelor în timpul ecluzării"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "74. Schiul nautic pe căile navigabile interioare este permis",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) numai în zonele stabilite şi marcate, acest lucru fiind valabil şi pentru activităţi în care persoanele sunt trase de o ambarcaţiune fără schiuri nautice sau pe altfel de obiecte",
                "b) fără restricţie de zonă, deoarece ambarcaţiunile au o viteză mare",
                "c) nu sunt reguli prevăzute special pentru schiul nautic"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "75. Când motorul este înclinat în jos la capătul cursei",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) barca glisează orizontal pe apă",
                "b) pupa bărcii va intra mai adânc în apă, la ambarcaţiunile mai mici se observă apuparea",
                "c) înclinarea motorului/cizmei nu influenţează alura deplasării"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "76. Pasul elicei reprezintă",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) mărimea diametrului butucului",
                "b) lungimea palei",
                "c) spaţiul parcurs de marginea exterioară a elicei, în mişcarea de translaţie efectuată de-a lungul axei de rotaţie în timpul unei rotaţii complete"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "77. Guvernarea clasică poate fi ajutată prin instalarea în corpul ambarcaţiunii de",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) propulsoare prova şi pupa (bowtruster si sterntruster)",
                "b) reducerea suprafeţei penei cârmei",
                "c) micşorarea unghiului de rotire a cârmei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "78. Conducerea de skyjet pe căile navigabile interioare",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) este interzisă",
                "b) este permisă numai în porţiunile stabilite şi marcate",
                "c) nu sunt reguli expres enunţate"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "79. Dacă barca pe care aţi cumpărat-o nu are placa de capacitate",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu este nici o problemă, parametrii limită de exploatare pot fi apreciaţi",
                "b) contactaţi dealer-ul dumneavoastră sau producătorul bărcii, pentru a intra în posesia informaţiilor garantate",
                "c) calculaţi dumneavoastră datele de care aveţi nevoie"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "80. Înainte de a părăsi locul de acostare",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) verificaţi funcţionarea butonului pentru oprire de urgenţă, daţi drumul motorului, trageţi saula şi vedeţi dacă motorul se opreşte; asiguraţi-vă că saula este bine legată de hainele sau vesta dumneavoastră de salvare",
                "b) nu se fac nici un fel de verificări",
                "c) nu trebuie legată saula de haine sau vesta de salvare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "81. Dacă pupa intră adânc în apă, datorită înclinării motorului la viteze mari",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) barca ar putea să înceapă să se rotească rapid şi să se arunce pasagerii peste bord",
                "b) barca îşi măreşte stabilitatea de drum",
                "c) nu se observă nici un efect"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "82. Esuarea involuntara a unei ambarcatiuni se intampla datorita:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cetii foarte dese;",
                "b) ploilor abundente;",
                "c) aparitiei bancurilor noi de corali."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "83. Esuarea voluntara se poate datora uneia din urmatoarele actiuni:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) necunoasterea zonei de navigatie;",
                "b) incercarea de a salva ambarcatiune si echipajul atunci cand ambarcatiune este avariata;",
                "c) cand ambarcatiune este incarcata prea mult, iar pentru descarcare acest lucru ar fi mai convenabil;"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "84. Daca o ambarcatiune este implicata intr-o situatie de urgenta, atunci comandantul va trebui sa raporteze:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) celui mai apropiat port si societatii de asigurare;",
                "b) pazei de coasta, autoritatii portuare si companiei;",
                "c) numai companiei;"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "85. Avem situatia de urgenta de \"defectiuni sistem de guvernare\". Masurile ce vor fi urmarite de a fi executate la punte sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) se informeaza comandantul, se semnalizeaza situatia, motorul principal se opreste, se pregatesc guvernarea de avarie, instalatiile de ancorare si remorcaj, se informeaza autoritatea cea mai apropiata si ambarcatiunile din vecinatate.",
                "b) se informeaza comandantul, se semnalizeaza situatia, se reduce turatia la motorul principal, se pregatesc guvernarea de avarie, instalatia de ancorare si remorcare, se informeaza autoritatea cea mai apropiata si ambarcatiunile din vecinatate;",
                "c) se informeaza comandantul, se reduce turatia la motorul principal, se pregatesc guvernarea de avarie, instalatia de ancorare si remorcaj, se informeaza autoritatea cea mai apropiata si ambarcatiunile din vecinatate;"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "86. In cazul unei coliziuni pe mare se iau urmatoarele actiuni imediate:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) se anunta comandantul, se constata avariile comise, se iau sonde in compartimentele avariate, se remediaza situatia;",
                "b) se anunta comandantul, se constata avariile la corpul ambarcatiunii si la marfa, se evalueaza pierderile si se iau sonde in compartimentul avariat, echipajul asteapta ordine, se pregateste instalatia de salvare, se au in vedere legatura radio, se semnalizeaza situatia",
                "c) se anunta comandantul, se constata pierderile suferite, se anunta autoritatea portuara cea mai apropiata;"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "87. In port se produce o coliziune, iar una dintre ambarcatiuni este grav avariata. Actiunile imediate ce vor fi luate sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) se anunta comandantul ambarcatiunii; se verifica daca sunt persoane ranite, avarii la corpul ambarcatiunii sau marfa; se pregateste echipamentul de salvare: se tine in \"stand-by\" statia radio; se da semnalul corespunzator; se inregistreaza ora si pozitia coliziuni",
                "b) se anunta comandantul ambarcatiunii si cu informatii de la alte ambarcatiuni din zona; se declara zona de trafic periculos, se iau masuri de remediere a avariei;",
                "c) se anunta comandantul ambarcatiunii, acesta anunta autoritatea portuara, se actioneaza imediat pentru remedierea avariilor, cere asistenta din partea altor ambarcatiuni;"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "88. La trecerea din apa dulce in apa sarata pescajul ambarcatiunii:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) se mareste;",
                "b) se micsoreaza;",
                "c) ramane constant."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "89. Stabilitatea ambarcatiunii pe valuri de urmarire se reduce in situatia in care:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) ambarcatiune se gaseste cu sectiunea maestra pe gol de val;",
                "b) ambarcatiune are viteza egala cu jumatate din viteza de propagare a valurilor;",
                "c) ambarcatiune se gaseste cu sectiunea maestra pe creasta de val."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "90. Pe timpul remorcajului, lungimea remorcii trebuie sa fie egala cu:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Jumatate din lungimea de unda a valului;",
                "b) Lungimea de unda a valului sau cu un multiplu al acestei marimi;",
                "c) Lungimea valului;"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "91. Ruperea unei parame de remorcaj pe timpul marsului de lunga durata se produce datorita faptului ca:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu s-a folosit o parama de remorcaj rezistenta, lunga, grea si suficient de elastica;",
                "b) S-a folosit o parama de remorcaj vegetala sau sintetica in loc de o parama metalica;",
                "c) In calculul rezistentei la rupere nu s-a tinut cont de diametrul paramei si de lungimea remorcii;"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "92. Manevra de apropiere de ambarcatiune ce urmeaza a fi remorcata in siaj, trebuie sa se faca:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Pe un drum paralel cu ambarcatiune remorcata si la o distanta de 5- 10 m;",
                "b) Pe acelasi drum cu ambarcatiune remorcata, la 10- 20 m, in prova acesteia;",
                "c) Pe un drum paralel cu ambarcatiune remorcata la o distanta de 20- 30 m, prin bordul din vant;"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "93. Care sunt procedeele de remorcaj?:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) In siaj, cuplat, mixt si prin impingere;",
                "b) In siaj la ureche si prin tragere;",
                "c) In siaj, la ureche, prin impingere, la edec si mixt."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "94. Pe timpul remorcajului schimbarile de drum:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Se fac progresiv pentru evitarea ruperii remorcii;",
                "b) Nu trebuie sa fie mai mari de 5 - 8 puncte la carma;",
                "c) Se fac astfel incat remorca sa aiba aceeasi tensiune ca si pe drum;"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "95. Pe timpul marsului la remorca se vor executa urmatoarele activitati:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Supravegherea permanenta a remorcii si respectarea vitezei de remorcaj;",
                "b) Calculul rezistentei la rupere, a diametrului si lungimii remorcii;",
                "c) Calculul rezistentei ambarcatiunii remorcate (RNR) si a tensiunii totale la care este supusa remorca;"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "96. Care din regulile urmatoare privind marsul cu ambarcatiune la remorca NU este corecta?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Se va evita pe cat posibil remorcajul pe langa coasta, in special cand vantul bate dinspre larg;",
                "b) Daca remorcherul trebuie sa intoarca, ambarcatiune remorcata trebuie sa orienteze carma in bordul intoarcerii pentru a slabi parama de remorcaj si astfel a inlesni intoarcerea;",
                "c) Marirea vitezei pe timpul marsului se va realiza din nod in nod;"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "97. Care din urmatoarele masuri de siguranta pe timpul remorcajului maritim NU este corecta?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Aprinderea luminilor, ridicarea semnelor si darea semnalelor de remorcaj, conform COLREG;",
                "b) Nu se va recurge la variatii mari ale vitezei de remorcaj;",
                "c) Pe timpul remorcajului nu se va mai modifica lungimea paramei de remorcaj."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "98. Care din urmatoarele operatiuni NU constituie masura de siguranta pe timpul remorcajului maritim:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Guvernarea ambarcatiunii remorcate trebuie sa se faca putin in afara siajului;",
                "b) Legarea remorcii se face numai la instalatiile special destinate acestui scop;",
                "c) Calculul rezistentei la rupere a remorcii in functie de directia vantului si curentului, de diametrul si lungimea remorcii"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "99. Pe timpul marsului in cadrul remorcajului cuplat, la manevra de intoarcere in bordul remorcherului",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Se va stopa masina remorcherului concomitent cu orientarea carmei in bordul intoarcerii, inertia ambarcatiunii ajutand la intoarcerea remorcherului;",
                "b) Se va stopa masina remorcherului asteptandu-se ca ambarcatiune remorcata sa-si piarda din inertie, apoi se va orienta carma in bordul intoarcerii si se va actiona masina treptat pana la viteza de mars;",
                "c) Se mareste viteza punandu-se si carma in bordul intoarcerii;"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "100. Pe timpul marsului in cadrul remorcajului cuplat, la manevra de intoarcere in bordul ambarcatiunii remorcate",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Se va stopa masina remorcherului concomitent cu orientarea carmei in bordul intoarcerii, inertia ambarcatiunii ajutand la intoarcerea remorcherului;",
                "b) Se va stopa masina remorcherului asteptandu-se ca ambarcatiune remorcata sa-si piarda din inertie, apoi se va orienta carma in bordul intoarcerii si se va actiona masina treptat pana la viteza de mars;",
                "c) Se mareste viteza punandu-se si carma in bordul intoarcerii;"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "101. Manevra de apropiere a ambarcatiunii de omul cazut in apa se executa:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Din inertie, cu masina stopata, astfel ca omul sa fie lasat in vantul ambarcatiunii",
                "b) Din inertie, cu pupa astfel ca omul sa poata fi recuperat mai usor din apa",
                "c) Din inertie, cu masina stopata, astfel ca omul sa fie lasat sub vantul ambarcatiunii"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "102. Algoritmul executarii manevrei de om la apa folosind curba lui WILLIAMSON este urmatorul:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Dupa ce s-a executat o intoarcere de 60gr cu carma banda in bordul in care a cazut omul, se orienteaza carma banda in bordul opus pentru a se ajunge la drum initial inversat",
                "b) Se executa o intoarcere de 60gr in oricare din cele doua borduri, dupa care se orienteaza carma banda in bordul opus pentru a se ajunge la drumul initial inversat",
                "c) Se pune carma banda in bordul in care s-a produs evenimentul si dupa o intoarcere de 250gr fata de drumul initial se aduce carma la zero si se stopeaza masina"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "103. Algoritmul executarii manevrei de om la apa folosind curba lui SCHRANOW este urmatorul:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Se executa o giratie completa in oricare dintre borduri si omul trebuie sa se gaseasca in punctul de incepere a manevrei",
                "b) Se pune carma banda in oricare dintre borduri si dupa o intoarcere la drumul de salvare calculat : Ds = Di + 180gr +/- 60gr, se va naviga pe acest drum pentru gasirea omului din apa",
                "c) Se pune carma banda in oricare dintre borduri, necunoscandu-se momentul cand a cazut omul in apa si dupa o intoarcere de 180gr se va executa cautarea"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "104. In cadrul activitatilor executate pentru recuperarea omului cazut in apa se apasa butonul \"Man over board\" al GPS-ului, in urmatorul scop:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) GPS-ul va indica continuu numai distanta pana la locul accidentului, permitand astfel reglarea vitezei pentru a putea opri ambarcatiune langa omul din apa",
                "b) GPS-ul va indica continuu numai relevmentul la locul accidentului, permitand astfel cunoasterea in orice moment a drumului ambarcatiunii spre om.",
                "c) Pentru a ghida permanent deplasarea ambarcatiunii spre locul accidentului, indicand continuu relevmentul si distanta."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "105. Pe timpul manevrei de om la apa pentru instiintarea in RTF a celorlalte ambarcatiuni din zona apropiata despre manevra:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Se lanseaza semnalul S.O.S",
                "b) Se lanseaza apelul si mesajul de primejdie: MAY DAY MAY DAY MAY DAY",
                "c) Se lanseaza apelul si mesajul de securitate SECURITE SECURITE SECURITE"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "106. Pentru executarea manevrei de om la apa prin giratie simpla se va proceda astfel:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Se pune carma banda in bordul in care a cazut omul si dupa o intoarcere de 250gr fata de drumul initial, se aduce carma la zero si se stopeaza masina",
                "b) Se pune carma banda in bordul in care a cazut omul si dupa o intoarcere de 360gr fata de drumul initial, se aduce carma la zero si se stopeaza masina",
                "c) Se pune carma banda in bordul in care a cazut omul si dupa o intoarcere de 180gr fata de drumul initial, se aduce carma la zero si se stopeaza masina"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "107. Pentru executarea manevrei de lansare la apa a ambarcatiunilor de salvare pe vreme rea este necesar ca:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) ambarcatiunile din jur sa fie informate de executarea manevrei",
                "b) Pozitia ambarcatiunii pe timpul lansarii sa fie pe cat posibil cu vantul in bordul opus lansarii",
                "c) Manevra sa fie inceputa de ofiterul de cart si apoi continuata de comandantul ambarcatiunii"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "108. Specificati care sunt factorii naturali care influenteaza manevra ambarcatiunii:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) vantul, valurile, curentii, adancimea apei, viteza ambarcatiunii;",
                "b) vantul, valurile, curentii, limitarea mediului inconjurator, gheturi, dimensiunile ambarcatiunii;",
                "c) vantul, valurile, curentii, adancimea apei, limitarea mediului inconjurator, gheturi."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "109. Specificati care sunt factorii tehnici care influenteaza manevra ambarcatiunii:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) elicea ambarcatiunii, vantul, carma, dimensiunile ambarcatiunii, viteza ambarcatiunii;",
                "b) carma, elicea, depunerile de gheata, viteza ambarcatiunii, spatiul de manevra;",
                "c) carma, elicea, viteza ambarcatiunii, dimensiunile ambarcatiunii."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "110. Calitatile nautice ale ambarcatiunii sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) stabilitatea, manevrabilitatea, comportarea ambarcatiunii fata de vant, nescufundabilitatea;",
                "b) nescufundabilitatea, flotabilitatea, stabilitatea;",
                "c) stabilitatea, flotabilitatea, manevrabilitatea, nescufundabilitatea."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "111. Calitatile manevriere ale ambarcatiunii sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) manevrabilitatea, comportarea ambarcatiunii fata de vant, oscilatiile ambarcatiunii, viteza, inertia, giratia;",
                "b) manevrabilitatea, stabilitatea, nescufundabilitatea, inertia, viteza, oscilatiile ambarcatiunii;",
                "c) manevrabilitatea, viteza, inertia, alura, comportarea fata de vant, oscilatiile ambarcatiunii."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "112. Mentionati varianta corecta - sensul legaturilor ambarcatiunii:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) parama prova-inainte; springul pupa-inapoi; traversa prova-spre prova;",
                "b) parama de etrava-inainte; parama de etambou-inainte; springul pupa-inainte;",
                "c) springul prova-inapoi; parama prova-inainte; parama pupa-inapoi."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "113. Mentionati varianta corecta - sensul legaturilor ambarcatiunii:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) parama prova-inapoi; springul pupa-inainte; traversa pupa-travers;",
                "b) parama de etambou-inapoi; parama de etrava-inainte; springul pupa-inainte;",
                "c) springul prova-inapoi; parama prova-inainte; parama pupa-inainte."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "114. Efectele legaturilor - parama prova:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) deplaseaza ambarcatiune in ax spre prova, apropie prova de cheu, departeaza pupa;",
                "b) deplaseaza ambarcatiune in ax spre prova, apropie pupa de cheu, departeaza prova;",
                "c) apropie prova de cheu, departeaza pupa."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "115. Efectele legaturilor - traversa prova:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) deplaseaza ambarcatiune spre inainte, apropie prova de cheu, departeaza pupa;",
                "b) apropie prova de cheu, departeaza pupa;",
                "c) deplaseaza ambarcatiune spre inapoi, apropie pupa de cheu, departeaza prova."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "116. Efectele legaturilor - springul prova:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) deplaseaza ambarcatiune spre inainte, apropie prova de cheu, departeaza pupa;",
                "b) deplaseaza ambarcatiune spre inapoi, apropie prova de cheu, departeaza pupa;",
                "c) deplaseaza ambarcatiune spre inapoi, apropie pupa de cheu, departeaza prova."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "117. Efectele legaturilor - parama pupa:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) deplaseaza ambarcatiune in ax spre pupa, apropie prova de cheu, departeaza pupa;",
                "b) deplaseaza ambarcatiune in ax spre prova, apropie pupa de cheu, departeaza prova;",
                "c) deplaseaza ambarcatiune in ax spre pupa, apropie pupa de cheu, departeaza prova."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "118. Efectele legaturilor - traversa pupa:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) apropie prova de cheu, departeaza pupa;",
                "b) apropie pupa de cheu, departeaza prova;",
                "c) deplaseaza ambarcatiune spre inapoi, apropie pupa de cheu, departeaza prova."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "119. Efectele legaturilor - springul pupa:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) deplaseaza ambarcatiune spre inainte, apropie prova de cheu, departeaza pupa;",
                "b) deplaseaza ambarcatiune spre inapoi, apropie prova de cheu, departeaza pupa;",
                "c) deplaseaza ambarcatiune spre inainte, apropie pupa de cheu, departeaza prova."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "120. Efectele legaturilor - parama de etrava/etambou:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) deplaseaza ambarcatiune spre inainte/inapoi de-a lungul cheului;",
                "b) deplaseaza ambarcatiune spre inainte/inapoi, apropie prova/pupa de cheu;",
                "c) deplaseaza ambarcatiune spre inainte/inapoi, departeaza prova/pupa de cheu."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "121. Efectele legaturilor combinate - parama prova si spring prova - faciliteaza:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) acostarea cu bordul, plecarea cu prova inainte pe parama prova;",
                "b) acostarea cu bordul, plecarea cu pupa inainte pe springul prova;",
                "c) acostarea cu bordul, plecarea cu prova inainte pe springul prova."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "122. Efectele legaturilor combinate - parama pupa si spring prova - faciliteaza:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) acostarea cu bordul, plecarea cu prova inainte pe springul prova;",
                "b) acostarea cu bordul, plecarea cu pupa inainte pe parama pupa;",
                "c) acostarea cu bordul, plecarea cu prova inainte pe springul pupa."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "123. Efectele legaturilor combinate - parama pupa si spring prova - faciliteaza:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) acostarea cu bordul, plecarea cu pupa inainte pe springul prova;",
                "b) acostarea cu bordul, plecarea cu pupa inainte pe parama pupa;",
                "c) acostarea cu bordul, plecarea cu prova inainte pe springul pupa."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "124. Efectele legaturilor combinate - parama prova si spring pupa - faciliteaza:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) apropierea ambarcatiunii de cheu cu deplasare spre inainte;",
                "b) apropierea ambarcatiunii de cheu cu deplasare spre inapoi;",
                "c) apropierea ambarcatiunii de cheu fara deplasare spre inainte/inapoi."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "125. Efectele legaturilor combinate - parama prova si spring prova - faciliteaza:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) apropierea ambarcatiunii de cheu cu deplasare spre inainte;",
                "b) apropierea ambarcatiunii de cheu cu deplasare spre inapoi;",
                "c) apropierea ambarcatiunii de cheu fara deplasare spre inainte/inapoi."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "126. Efectul carmei la mars inainte - ambarcatiune merge inainte, carma in ax:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prova gireaza la stanga, iar pupa abate spre dreapta;",
                "b) prova gireaza la dreapta, iar pupa abate spre stanga;",
                "c) deplasare rectininie inainte."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "127. Efectul carmei la mars inainte - ambarcatiune merge inainte, carma dreapta:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prova gireaza la stanga, iar pupa abate spre dreapta;",
                "b) prova gireaza la dreapta, iar pupa abate spre stanga;",
                "c) deplasare rectininie inainte."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "128. Efectul carmei la mars inainte - ambarcatiune merge inainte, carma stanga:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prova gireaza la stanga, iar pupa abate spre dreapta;",
                "b) prova gireaza la dreapta, iar pupa abate spre stanga;",
                "c) deplasare rectininie inainte."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "129. Efectul carmei la mars inapoi - ambarcatiune merge inapoi, carma in ax:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prova gireaza la stanga, iar pupa abate spre dreapta;",
                "b) prova gireaza la dreapta, iar pupa abate spre stanga;",
                "c) deplasare rectininie inapoi."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "130. Efectul carmei la mars inapoi - ambarcatiune merge inapoi, carma dreapta:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prova gireaza la stanga, iar pupa abate spre dreapta;",
                "b) prova gireaza la dreapta, iar pupa abate spre stanga;",
                "c) deplasare rectininie inapoi."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "131. Efectul carmei la mars inapoi - ambarcatiune merge inapoi, carma stanga:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prova gireaza la stanga, iar pupa abate spre dreapta;",
                "b) prova gireaza la dreapta, iar pupa abate spre stanga;",
                "c) deplasare rectininie inapoi."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "132. Efecte combinate carma-elice - ambarcatiune merge cu viteza inainte, carma zero, masina inainte:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prova gireaza la stanga, pupa abate la dreapta;",
                "b) prova gireaza la dreapta, pupa abate la stanga;",
                "c) elicea nu are efect."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "133. Efecte combinate carma-elice - ambarcatiune merge cu viteza inainte, carma dreapta, masina inainte:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prova gireaza la stanga, pupa abate la dreapta;",
                "b) prova gireaza la dreapta, pupa abate la stanga;",
                "c) elicea nu are efect."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "134. Efecte combinate carma-elice - ambarcatiune merge cu viteza inainte, carma stanga, masina inainte:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prova gireaza la stanga, pupa abate la dreapta;",
                "b) prova gireaza la dreapta, pupa abate la stanga;",
                "c) elicea nu are efect."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "135. Efecte combinate carma-elice - ambarcatiune merge cu viteza inapoi, carma zero, masina inapoi:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prova gireaza la stanga, pupa abate la dreapta;",
                "b) prova gireaza la dreapta, pupa abate la stanga;",
                "c) elicea nu are efect."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "136. Efecte combinate carma-elice - ambarcatiune merge cu viteza inapoi, carma dreapta, masina inapoi:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prova gireaza la stanga, pupa abate la dreapta;",
                "b) prova gireaza la dreapta, pupa abate la stanga;",
                "c) elicea nu are efect."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "137. Efecte combinate carma-elice - ambarcatiune merge cu viteza inapoi, carma stanga, masina inapoi:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prova gireaza la stanga, pupa abate la dreapta;",
                "b) prova gireaza la dreapta, pupa abate la stanga;",
                "c) elicea nu are efect."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "138. Acostarea reprezinta apropierea unei ambarcatiuni de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cheu, debarcader, mal, geamandura, loc neamenajat, alta ambarcatiune;",
                "b) cheu, platforma, canal, debarcader, ecluza, loc neamenajat, alta ambarcatiune;",
                "c) cheu, doc, platforma, debarcader, fluviu, geamandura, alta ambarcatiune."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "139. La acostarea cu babordul la cheu, fara ancora, apropierea se face:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) sub un unghi cat mai mic (20-30 grade), pentru o ambarcatiune cu elice pas dreapta;",
                "b) sub un unghi cat mai mic (10-20 grade), pentru o ambarcatiune cu elice pas dreapta;",
                "c) sub un unghi cat mai mare, folosind efectul carmei si elicei."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "140. La acostarea cu tribordul la cheu, fara ancora, apropierea se face:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) sub un unghi cat mai mic (20-30 grade), pentru o ambarcatiune cu elice pas dreapta;",
                "b) sub un unghi cat mai mic (10-20 grade), pentru o ambarcatiune cu elice pas dreapta;",
                "c) sub un unghi cat mai mare, folosind efectul carmei si elicei."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "141. Acostarea cu pupa la cheu, prin intoarcere si fundarisirea ancorei la mars inapoi se face astfel:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) funda ancora, stop masina, darea paramei de etambou, foarte incet inainte, stop masina;",
                "b) funda ancora, foarte incet inapoi, darea mustatilor pupa, stop masina;",
                "c) funda ancora, foarte incet inainte, darea paramei de etambou, foarte incet inainte, stop."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "142. Manevra de acostare cu pupa se poate face prin urmatoarele metode:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu sau fara ajutorul ancorei;",
                "b) cu sau fara ajutorul remorcherului;",
                "c) cu sau fara legaturi prova."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "143. Manevra de plecare de la cheu este mai rapida in cazul:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) unei ambarcatiuni acostate cu bordul la cheu;",
                "b) unei ambarcatiuni acostate cu pupa la cheu;",
                "c) unei ambarcatiuni acostate cu prova la cheu."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "144. Manevra de legare/plecare la/de la geamandura consta in urmatoarele operatiuni:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pregatirea ambarcatiunii, prezentarea la geamandura, legarea, plecarea;",
                "b) prezenta, pregatirea echipajului, legarea, voltarea, plecarea;",
                "c) pregatirea legaturilor, apropierea de geamandura, legarea, voltarea, plecarea, largarea."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "145. Apropierea de geamandura sau o alta ambarcatiune este mai usoara, daca conditiile permit:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu vantul/curentul din prova;",
                "b) cu vantul/curentul din pupa;",
                "c) cu vantul/curentul din travers."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "146. Manevra pe parame (shifting) se executa:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pe distante mici;",
                "b) pe distante mari, cu remorchere si pilot la bord;",
                "c) pe distante mici, cu remorchere, dar fara pilot la bord"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "147. Manevra de plecare de la cheu a unei ambarcatiuni acostata cu bordul babord, elice pas dreapta:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) mola pupa, carma dreapta, masina inainte;",
                "b) mola pupa, carma stanga, masina inainte;",
                "c) mola pupa, carma stanga, masina inapoi."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "148. Manevra de plecare de la cheu a unei ambarcatiuni acostata cu bordul tribord, elice pas dreapta:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) mola pupa, carma dreapta, masina inainte;",
                "b) mola pupa, carma stanga, masina inainte;",
                "c) mola pupa, carma stanga, masina inapoi."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "149. Plecarea unei ambarcatiuni cu doua elice acostata cu babordul la cheu, pe timp bun:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) mola pupa, masina babord inainte, masina tribord inapoi;",
                "b) mola pupa, masina babord inapoi, masina tribord stop;",
                "c) mola pupa, masina babord inapoi, masina tribord inainte."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "150. Plecarea unei ambarcatiuni cu doua elice acostata cu tribordul la cheu, pe timp bun:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) mola pupa, masina babord inainte, masina tribord inapoi;",
                "b) mola pupa, masina tribord inapoi, masina babord stop;",
                "c) mola pupa, masina babord inapoi, masina tribord inainte."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "151. Calculul locului de ancorare tine cont de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lungimea ambarcatiunii, natura fundului, existenta reperelor de navigatie, adancimea apei;",
                "b) adancimea apei, lungimea ambarcatiunii, posibilitatea graparii ancorei, eroarea in punct;",
                "c) latimea ambarcatiunii, panta fundului, posibilitatea graparii ancorei, adancimea apei."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "152. Procedee de ancorare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu o ancora, cu doua ancore;",
                "b) cu o ancora, cu doua ancore, cu trei ancore;",
                "c) cu o ancora, cu doua ancore, cu trei ancore, cu sase ancore."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "153. Ancorarea la mars inainte, pe calm si fara curent:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) carma in bordul opus bordului ancorarii, se parcurge spatiul L/2, dupa care se da funda ancora;",
                "b) carma in bordul ancorarii, se parcurge spatiul L/2, dupa care se da funda ancora;",
                "c) carma zero, se parcurge spatiul L/2, dupa care se da funda ancora."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "154. Unghiul format intre lanturi la ancorarea in barba este de maximum:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 30 grade;",
                "b) 60 grade;",
                "c) 180 grade."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "155. Ancorarea in barba este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) mai sigura decat ancorarea cu o singura ancora;",
                "b) mai nesigura decat ancorarea cu o singura ancora;",
                "c) la fel de sigura ca si ancorarea cu o singura ancora."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "156. Ancorare prin afurcare se poate face prin urmatoarele metode:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la mars inainte si la mars inapoi;",
                "b) la mars inainte, stop si la mars inapoi;",
                "c) la stop si la mars inapoi."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "157. La manevra de ancorare prin afurcare se folosesc urmatoarele:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o ancora si un spring;",
                "b) doua ancore;",
                "c) doua ancore si un spring."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "158. Manevra de ambosare reprezinta:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) mentinerea ambarcatiunii la adapost de vant/valuri/curenti;",
                "b) mentinerea ambarcatiunii intr-o pozitie voita, indiferent de vant/valuri/curenti;",
                "c) mentinerea ambarcatiunii in orice pozitie, cu ajutorul unei ancore si un spring."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "159. Ambosarea cu spring se face de regula:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu ambarcatiune la mars inainte;",
                "b) cu ambarcatiune stopata, cand vantul este sub forta 6-7;",
                "c) cand ambarcatiune mai are inertie catre inapoi."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "160. La ambosarea prin legarea unui spring la ancora fundarisita, gasa springului se aduce:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de la pupa, pe puntea principala;",
                "b) de la pupa, prin exteriorul bordajului;",
                "c) de la pupa, prin bordul opus ancorarii."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "161. Ambosarea ambarcatiunii cu doua ancore (ancora si ancorot) se face:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu o ambarcatiune ancorata;",
                "b) cu o ambarcatiune ancorata sau cu o ambarcatiune care se deplaseaza;",
                "c) cu o ambarcatiune in mars."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "162. La manevra de ambosare prin ancorare si legare la geamandura, la ancoraj se vine astfel:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin apropierea la travers de geamandura, trecand pe langa si prin vantul ei;",
                "b) prin apropiere de geamandura din inertie si cu vant din prova;",
                "c) prin apropiere de geamandura cu viteza mica si cu vant din travers."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "163. Stationarea ambarcatiunii la ancora presupune respectarea regulilor:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) SOLAS 74;",
                "b) COLREG 72;",
                "c) INCOTERMS."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "164. La manevra de ancorare, pozitia lantului se raporteaza:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la fiecare minut;",
                "b) la fiecare cheie de lant;",
                "c) la fiecare za de lant."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "165. Manevra de remorcaj afecteaza calitatile manevriere ale ambarcatiunii, dupa cum urmeaza:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) manevrabilitatea, inertia si oscilatiile ambarcatiunii;",
                "b) viteza, inertia si giratia ambarcatiunii;",
                "c) comportarea ambarcatiunii fata de vant, inertia si viteza."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "166. Remorcherele oceanice au zona de navigatie:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) costiera;",
                "b) oceanica;",
                "c) nelimitata."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "167. Diferenta intre tipurile de remorchere o face:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) zona de navigatie, puterea motorului, dependenta fata de portul de baza;",
                "b) calitatile manevriere, calitatile nautice, dotarea cu echipamente de salvare;",
                "c) viteza de remorcare, vizibilitatea buna la manevra, lungimea remorcii."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "168. Misiunile remorcherelor sunt, printre altele:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) remorcajul, cautare si salvare pe mare, spargerea ghetii;",
                "b) stingerea incendiilor, prevenirea si limitarea poluarii cu hidrocarburi;",
                "c) salvarea pe mare, aprovizionarea ambarcatiunilor, manevra de andocare."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "169. Procedee de remorcaj:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) in siaj, la ureche, in barba, mixt;",
                "b) in siaj, la ureche, prin impingere, la edec, mixt;",
                "c) in siaj, la ureche, la edec, mixt."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "170. Pregatirile preliminare ale manevrei de remorcaj presupun:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) alegerea remorcherului, alegerea remorcii, alegerea zonei de remorcaj;",
                "b) alegerea remorcherului, pregatirea ambarcatiunii remorcate, pregatirea echipajului;",
                "c) alegerea remorcherului, alegerea remorcii, pregatirea ambarcatiunii remorcate, pregatirea remorcherului."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "171. Alegerea remorcii se face functie de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) material, rezistenta, lungime, grosime;",
                "b) lungimea convoiului, latimea ambarcatiunii, puterea remorcherului;",
                "c) rezistenta la inaintare, coeficientul bloc, dimensiunile ambarcatiunii remorcate."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "172. Pistolul de aruncare a bandulei foloseste la:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) apropierea intre ambarcatiune si remorcher;",
                "b) baterea bandulei intre remorcher si ambarcatiune remorcata.",
                "c) aruncarea bandulei catre remorcher."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "173. Distanta optima de apropiere a remorcherului la travers de ambarcatiune remorcata este de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 30-50m;",
                "b) 60-80m;",
                "c) 20-30m."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "174. Marsul la remorca se face conform regulilor:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) COLREG 72;",
                "b) SOLAS 60;",
                "c) MARPOL 73/78."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "175. Schimbarile de drum pe timpul remorcajului trebuie sa se efectueze:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lent, cu un numar mic de grade;",
                "b) brusc, spre bordul dorit, cu un numar mic de grade;",
                "c) lent, o schimbare considerabila de grade."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "176. Intinderea remorcii se va face astfel:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) brusc, pentru a realiza intinderea adecvata necesara remorcajului in siguranta;",
                "b) lent, progresiv, pentru a evita ruperea remorcii;",
                "c) numai in momentul cand ambarcatiune se afla la distanta suficienta de remorcher."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "177. Lungimea remorcii la remorcajul portuar fata de remorcajul maritim este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) mai mare cu 25-30%;",
                "b) mai mica, aproximativ 25-30m;",
                "c) aceeasi."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "178. Remorcajul in siaj cu prova inainte este mai:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) avantajos, deoarece rezistenta ambarcatiunii la inaintare este mai mica;",
                "b) dezavantajos, deoarece necesita spatii mai largi;",
                "c) avantajos, deoarece se pot folosi la remorcaj si ambarcatiuni nespecializate."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        },
        {
            "question": "179. Remorcajul la ureche se foloseste:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pentru ambarcatiuni mari, pe distanta scurte, in conditii meteo favorabile;",
                "b) pentru ambarcatiuni mici, pe distante scurte, pe mare calma, in zona portuara;",
                "c) pentru ambarcatiuni mici si mijlocii, in rada porturilor."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Manevra meteo hidrologie",
            "difficulty": 1
        }
    ]
};
